<div class="partner-employees-body">
    <!--Header-->
    <div class="flex flex-row" style="margin-bottom: 20px;">
        <div *ngIf="typeMerchantUser === typeMerchantUserEnum.StoreEmployees" class="partner-employees-header-label">
            Store Employees
        </div>

        <div *ngIf="typeMerchantUser === typeMerchantUserEnum.WebAdmins" class="partner-employees-header-label">
            Partner Portal Employees
        </div>

        <div style="margin-left: auto; margin-right: 15px;">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" class="search-input"
                       [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                       placeholder="Search here..." style="height: 45px; width: 280px;" />
            </span>
        </div>
        <div>
            <button style="height: 45px;" pButton pRipple class="btn-darkblue" [label]="'Create Employee'" icon="pi pi-plus" (click)="op.toggle($event)"></button>
            <p-overlayPanel #op [style]="{width: '180px'}">
                <ng-template pTemplate>
                    <button (click)="handleShowCreateEmployee(typeMerchantUserEnum.StoreEmployees)" pButton type="button" label="Store Employee" class="p-button-text"></button>
                    <button (click)="handleShowCreateEmployee(typeMerchantUserEnum.WebAdmins)" pButton type="button" label="Web Admins" class="p-button-text"></button>
                </ng-template>
            </p-overlayPanel>
        </div>
    </div>
    <!-- Table -->
    <div style="height: calc(100vh - 250px);">
        <p-table #merchantUsersGrid
                 [columns]="cols"
                 [value]="merchantUsers"
                 [lazy]="true"
                 [loading]="loading"
                 responsiveLayout="scroll" dataKey="UserId"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [(selection)]="selectedUsers"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-striped'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                    </th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-merchantUser>
                <tr [pSelectableRow]="merchantUser">
                    <td class="ui-resizable-column">{{merchantUser.UserId}}</td>
                    <td class="ui-resizable-column">{{merchantUser.UserName}}</td>
                    <td class="ui-resizable-column">{{merchantUser.RoleName}}</td>
                    <td class="ui-resizable-column">{{merchantUser.CreatedAt}}</td>
                    <td class="ui-resizable-column">{{merchantUser.Store.Name}} | {{merchantUser.Store.Address}} {{merchantUser.Store.AddressDetails}}</td>
                    <td class="ui-resizable-column"><span [class]="'partner-employee-status-' + merchantUser.StatusForClass">{{merchantUser.IsSuspended ? 'Suspend' : merchantUser.StatusStr}}</span></td>
                    <td>
                        <span class="action-icon-svg" (click)="openMerchantEmployeeDetailSideBar(merchantUser)">
                            <img src="../Content/xpress-app/images/svg/icon_edit.svg" />
                        </span>
                        <span class="action-icon-svg" (click)="showSuspendEmployeeDialog(merchantUser)">
                            <img src="../Content/xpress-app/images/svg/icon_suspend_yellow.svg" />
                        </span>
                        <span class="action-icon-svg" (click)="showDeleteEmployeeDialog(merchantUser)">
                            <img src="../Content/xpress-app/images/svg/icon_trash.svg" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="merchantUsers.length > 0" style="padding-left: 10px">
                    Displaying {{first + 1}} - {{first + merchantUsers.length}} of {{totalRecords}}
                </div>
            </ng-template>
        </p-table>
    </div>

</div>

<partner-delete-employee *ngIf="showDeleteEmployee" [showDeleteEmployee]="showDeleteEmployee" [merchantUser]="selectedUser" [onHide]="handleDeleteEmployeeHide"></partner-delete-employee>
<partner-suspend-employee *ngIf="showSuspendEmployee" [showSuspendEmployee]="showSuspendEmployee" [merchantUser]="selectedUser" [onHide]="handleSuspendEmployeeHide"></partner-suspend-employee>
<partner-employee-details *ngIf="showEmployeeDetails" [visible]="showEmployeeDetails" [onHide]="handleEmployeeDetailsPopupHide" [employee]="selectedUser"></partner-employee-details>
<create-merchant-employee [visible]="showCreateEmployee" [typeCreatedEmployee]="typeCreatedEmployee" [showEditFields]="true"
                          [onHide]="handleCreatePopupHide" [merchantId]="merchantId" [isCreateEmployee]="true"></create-merchant-employee>
